import type { ExperimentPlan } from 'helpers/experiment-plan';

export const pct = (ratio: number, digits = 1) => `${(ratio * 100).toFixed(digits)}%`;

/**
 * "est. 4 weeks", "est. 10 days", "est. over a year", or "Not enough data".
 *
 * Every length carries "est." because every one is: it rests on traffic and a rate
 * that describe the past, and a run is only as long as the traffic that actually comes.
 */
export const formatRunLength = (plan: ExperimentPlan | null): string => {
  if (!plan) return 'Not enough data';
  if (plan.recommendedDays === null) return 'est. over a year';
  const days = plan.recommendedDays;
  return `est. ${days % 7 === 0 ? `${days / 7} weeks` : `${days} days`}`;
};
